import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Breadcrumb from "components/Common/Breadcrumb2";
import { Button, Spinner } from "reactstrap";
import { fetchStudentProfileRequest } from "store/actions";
import StudentProfileCard from "components/cards/StudentProfileCard";
import StudentAttendanceCard from "components/cards/StudentAttendanceCard";
import StudentAssignmentCard from "components/cards/StudentAssignmentCard";


const StudentProfile = () => {
  const { id } = useParams(); 
  const dispatch = useDispatch();

  const { loading, profile } = useSelector((state) => state.Student);

  useEffect(() => {
    if (id) {
      dispatch(
        fetchStudentProfileRequest(id, {
          page: 1,
          limit: 10,
          status: "reviewed",
        })
      );
    }
  }, [dispatch, id]);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
        <Spinner color="primary" />
      </div>
    );

  if (!profile)
    return (
      <div className="text-center mt-5">
        <h5>No Profile Data Found</h5>
      </div>
    );

  return (
    <div className="page-content container-fluid">
      <div className="d-flex justify-content-between align-items-center mx-3 mb-4">
      <Breadcrumb
        title="Student Profile"
        breadcrumbItems={[
          { title: "Dashboard", link: "/dashboard" },
          { title: "Students", link: "/students" },
          { title: profile?.studentInfo?.name, link: "#" },
        ]}
      />
              <Link to="/students">
                <Button color="secondary">Back</Button>
              </Link>
              </div>

      <StudentProfileCard data={profile.studentInfo} />
      <StudentAttendanceCard data={profile.attendance} />
      <StudentAssignmentCard data={profile.assignments} studentId={id} />
    </div>
  );
};

export default StudentProfile;
